import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setPostConstructionPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const usePostConstructionSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getPostConstructionSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.post_construction_page?.post_construction_section}`);
      console.log("🚀 ~ getPostConstructionSectionJson ~ data:", response);
      console.log("🚀 ~ getPostConstructionSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setPostConstructionPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Post Construction section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getPostConstructionSectionJson();
  }, [getPostConstructionSectionJson]);

  return {
    data,
    loading,
    error,
    getPostConstructionSectionJson,
    fetchOnMount,
    refetch: getPostConstructionSectionJson
  };
};

export default usePostConstructionSection;
